
import params from './modules/params'

export default {
  params,
}
